import React from 'react';
import PageHeader from '../../../../components/PageHeader';
import Datatable from '../../../../components/DataTable';
import { Box, Button, IconButton, Stack, TablePagination, Typography } from '@mui/material';
import TablePaginationActions from '../../../../components/TablePaginationActions';
import { useState } from 'react';
import { useTheme } from '@emotion/react';
import { useDispatch, useSelector } from 'react-redux';
import { CancelToken } from 'apisauce';
import { useEffect } from 'react';
import appapi from '../../../../api/apiClient';
import { buttonStyle2 } from '../../../../utils/commonStyle';
import { setLoading } from '../../../../redux/features/appSlice';
import { showmessage } from '../../../../utils/toastr';



export default function AddTraderList({ handleClose, companyId }) {
  const theme = useTheme();

  const dispatch = useDispatch();

  const [payload, setPayload] = useState({
    page: 1,
    limit: 10,
    filter: null,
    totalLength: 0,
    paginationPage: 0,
    field: '_id',
    sortOrder: 'desc',
  });

  const [tradersList, setTradersList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  let source = CancelToken.source();


  const columns = [
    {
      id: 0,
      header: '#',
      accessor: 'Sno',
      width: '10%',
    },
    {
      id: 1,
      header: 'Trader',
      accessor: 'traderName',
      width: '70%',
    },
    {
      id: 3,
      header: 'Status',
      accessor: 'status',
      width: '20%',
      Cell: (item) => (
        <div className="flex !justify-center">
          <Button
            sx={[
              {
                height: '28px',
                width: '80px',
                borderRadius: '16px',
                fontSize: '12px',
                fontWeight: 500,
                color: theme.palette.background.main,
                backgroundColor: theme.palette.primary.light,
                '&:hover': {
                  backgroundColor: theme.palette.primary.main,
                  color: theme.palette.background.main,
                },
                '&:disabled': {
                  color: 'rgba(255,255,255,0.5)',
                  backgroundColor: theme.palette.primary.main,
                },
              },
            ]}
            onClick={() => requestTrader(item._id)}
            variant="contained"
          >
            ADD
          </Button>
        </div>
      ),
    },
  ];

  const requestTrader = async (traderId) => {
    dispatch(setLoading(true));
    const response = await appapi.post(
      `/company/requestTrader`,
      {},
      {
        params: {
          companyId: companyId,
          traderId,
        },
      },
    );
    if (response.ok) {
      dispatch(setLoading(false));
      const data = response.data;
      if (data.status === '7400') {
        setPayload((prev) => ({ ...prev, paginationPage: 1, page: 1, filter: payload.filter }));
        handleGetTrader();
        showmessage(data.message, 'success');
      } else {
        showmessage(data.message, 'error');
      }
    } else {
      dispatch(setLoading(false));
      showmessage(`Something Went Wrong!`, 'error', 2000);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPayload((prevState) => ({ ...prevState, page: newPage + 1, paginationPage: newPage, filter: payload.filter }));
  };

  const handleChangeRowsPerPage = (event) => {
    setPayload((prev) => ({ ...prev, limt: parseInt(event.target.value, 10), paginationPage: 1, page: 1, filter: payload.filter }));
  };

  //search filter
  const handleSearchEmit = (search) => {
    setPayload((prevState) => ({ ...prevState, limt: 10, paginationPage: 0, page: 1, filter: search }));
  };

  const handleGetTrader = async () => {
    setIsLoading(true);
    if (source) {
      source.cancel();
    }
    source = CancelToken.source();
    const response = await appapi.get(
      `/company/allTraders/${companyId}`,
      {
        pageNumber: payload.page,
        filter: payload.filter ? payload.filter : null,
        pageSize: payload.limit,
        field: payload.field,
        sortOrder: payload.sortOrder,
      },
      { cancelToken: source.token },
    );
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        let userData = data?.response;
        userData.map((item, index) => {
          item.Sno = payload.limit * (payload.page === 1 ? 0 : payload.page - 1) + index + 1;
          return item;
        });
        setTradersList(userData);
        setPayload((prev) => ({ ...prev, totalLength: data?.length, paginationPage: payload.page === 1 ? 0 : payload.page - 1 }));
        setIsLoading(false);
      } else {
        setTradersList([]);
        setPayload((prev) => ({ ...prev, totalLength: 0, paginationPage: 0 }));
        setIsLoading(false);
      }
    } else {
      setTradersList([]);
      setPayload((prev) => ({ ...prev, totalLength: 0, paginationPage: 1 }));
      // setIsLoading(false);
    }
  };

  useEffect(() => {

    handleGetTrader();
    return () => {
      if (source) {
        source.cancel("Operation canceled by the user.");
      }
    };
    // eslint-disable-next-line
  }, [payload.page, payload.filter]);
  return (
    <Stack
      flex={1}
      style={{ backgroundColor: '#F2F3F580', borderRadius: '8px', padding: '16px', borderColor: '#8993AC26', borderWidth: '1px' }}
    >
      <Stack >
        <PageHeader
          tableType={'2'}
          headerColor={'#003399'}
          showCloseBtn={true}
          handleClose={handleClose}
          handleOnSearchEmit={(search) => {
            handleSearchEmit(search);
          }}
          searchBarWidth={'150px'}
        >
          <Stack direction="row">
            <Stack style={{ paddingLeft: '10px' }}>
              <Typography
                className="fs-14 ff-Roboto fw-regular"
                color={'#FFFFFF'}
              >
                Add Trader
              </Typography>
              <Typography
                className="fs-10 ff-Roboto fw-regular"
                color={'#FFFFFF99'}
              >
                Select traders and request to KYC verification
              </Typography>
            </Stack>
            <Stack flexGrow={1} />
            {/* <IconButton
              onClick={() => {}}
              className=""
            >
              <Typography
                color={'#FFFFFF'}
                className="fs-14 ff-Roboto fw-medium"
              >
                REQUEST
              </Typography>
            </IconButton> */}
          </Stack>
        </PageHeader>
        <Stack flex={1}>
          <div className="pb-[16px] relative  bg-[#f7f7f7]  inputFormStyle">
            <Stack className="">
              <Datatable
                themeType={2}
                columns={columns}
                data={tradersList}
                isLoading={isLoading}
              />
            </Stack>
            {payload.totalLength > 0 && <Box className="flex justify-end items-center h-[56px] w-[100%] p-[5px] bg-[#FFFF]  mb-[10px] mr-[10px] rounded-b-lg">
              <TablePagination
                rowsPerPageOptions={[]}
                count={payload.totalLength ? payload.totalLength : 0}
                rowsPerPage={payload.limit ? payload.limit : 10}
                page={payload.paginationPage ? payload.paginationPage : 0}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </Box>}
          </div>
        </Stack>
      </Stack>
    </Stack>
  );
}
